import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignatoriesAuthComponent } from './components/signatures-wrapper/signatories-auth/signatories-auth.component';
import { SignaturesWrapperComponent } from './components/signatures-wrapper/signatures-wrapper.component';
import { SignatoryRequestOtpCodeComponent } from './components/signatures-wrapper/signatories-auth/signatory-request-otp-code/signatory-request-otp-code.component';
import { SignatoryVerifyOtpCodeComponent } from './components/signatures-wrapper/signatories-auth/signatory-verify-otp-code/signatory-verify-otp-code.component';
import { SignComponent } from './components/signatures-wrapper/sign/sign.component';
import { DocumentViewerComponent } from './components/signatures-wrapper/sign/document-viewer/document-viewer.component';
import { DocumentSignerComponent } from './components/signatures-wrapper/sign/document-signer/document-signer.component';
import { HomeComponent } from './components/home/home.component';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import {MatSliderModule} from '@angular/material/slider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HideStarsPipe } from './pipes/hide-stars.pipe';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { AcceptConditionsDialogComponent } from './components/signatures-wrapper/sign/document-viewer/accept-conditions-dialog/accept-conditions-dialog.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { PopupProgressSigningComponent } from './components/signatures-wrapper/sign/document-signer/popup-progress-signing/popup-progress-signing.component';
import { SignatureLinkInvalidatedComponent } from './components/signatures-wrapper/signature-link-invalidated/signature-link-invalidated.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { environment } from 'src/environments/environment';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { MatSelectModule } from '@angular/material/select';
import * as Sentry from "@sentry/angular";
import { Router } from '@angular/router';

// Export this function
export function playerFactory(): any {
  return import('lottie-web');
}

export function HttpLoaderFactory (http: HttpClient) {
  return new TranslateHttpLoader(http)
}


@NgModule({
  declarations: [
    AppComponent,
    SignaturesWrapperComponent,
    SignatoriesAuthComponent,
    SignatoryRequestOtpCodeComponent,
    SignatoryVerifyOtpCodeComponent,
    SignComponent,
    DocumentViewerComponent,
    DocumentSignerComponent,
    HomeComponent,
    HideStarsPipe,
    AcceptConditionsDialogComponent,
    PopupProgressSigningComponent,
    SignatureLinkInvalidatedComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    PdfViewerModule,
    AngularSignaturePadModule,
    MatSliderModule,
    FormsModule,
    LottieModule.forRoot({ player: playerFactory }),
    RecaptchaV3Module,
    BrowserAnimationsModule,
    MatSelectModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [

    // interceptors
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha_key },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
